"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.payoutFactory = void 0;
const Factory = require("factory.ts");
const mocks_1 = require("../../../mocks");
exports.payoutFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    currency_type: 'USD',
    department: 'department',
    gross_less_refunds: 100,
    payout_bank_account: '123456789',
    payout_bank_account_name: mocks_1.persona.full_name,
    payout_configuration_type_id: 1,
    payout_date: mocks_1.dates.date2100,
    payout_deposit_date: mocks_1.dates.date2000,
    payout_fee_subtotal: 10,
    payout_forward: 'forward',
    payout_group_type_id: 1,
    payout_id: Factory.each(i => i + 1),
    payout_other_subtotal: 5,
    payout_payment_subtotal: 50,
    payout_processor: 'processor',
    payout_processor_id: 'processor_id',
    payout_refund_subtotal: 0,
    payout_status: 'completed',
    payout_total: 100,
    payout_type: 'type',
    payout_url: 'https://example.com/payout',
    source_system: 'system',
    source_system_id: 1,
    tenant_id: 1,
    tenant_name: 'tenant_name',
    tenant_name_suffix: 'suffix',
    tenant_payout_date: mocks_1.dates.date2000,
    tenant_payout_deposit_date: mocks_1.dates.date2000,
    tenant_transaction_date: mocks_1.dates.date2000,
    tenant_type: 'tenant_type',
});
